import contentTypes from "astrid-distribution/src/constants/contentTypes";

import articleTypes from "../articles/constants/articleTypes";

import artifactContentTypes from "./constants/artifactContentTypes";

export default function getAcceptedArtifactFiles(article) {
	switch (article?.type) {
		case articleTypes.EBOOK:
			return {
				[artifactContentTypes.EPUB]: [".epub"],
				[artifactContentTypes.PDF]: [".pdf"],
			};

		case articleTypes.AUDIOBOOK:
		case articleTypes.PODCAST:
			return {
				[artifactContentTypes.MP3]: [".mp3"],
				[artifactContentTypes.WAV]: [".wav"],
				[contentTypes.ZIP]: [".zip"],
			};

		default:
			return {
				[artifactContentTypes.WAV]: [".wav"],
				[artifactContentTypes.EPUB]: [".epub"],
				[artifactContentTypes.PDF]: [".pdf"],
				[contentTypes.ZIP]: [".zip"],
			};
	}
}
